import { useState } from 'react';
import PLForm, { blankPL } from '../components/PLForm';

/* P&L Sheet page — a blank Project Profitability sheet to fill in and print.
   Nothing here is saved; for a job's saved P&L use the P&L tab on Update Record. */
const BAR = `
.pl-bar{display:flex;flex-wrap:wrap;gap:10px;align-items:center;margin-bottom:16px}
.pl-btn{border:1px solid #0D3B2E;background:#0D3B2E;color:#fff;border-radius:10px;padding:9px 16px;font-weight:700;font-size:13px;cursor:pointer}
.pl-btn.alt{background:#fff;color:#0D3B2E}
`;

export default function PLSheet() {
  const [f, setF] = useState(blankPL);
  return (
    <>
      <style>{BAR}</style>
      <div className="page-header">
        <h2>P&amp;L Sheet</h2>
        <div style={{ fontSize: 13, color: '#888' }}>A blank Project Profitability sheet. Type in each line — totals and marketing commissions work themselves out. Nothing is saved here; a job's own P&amp;L lives in its P&amp;L tab on Update Record. Admins only.</div>
      </div>
      <div className="page-body">
        <div className="pl-bar">
          <button className="pl-btn alt" type="button" onClick={() => { if (window.confirm('Clear everything typed on this sheet?')) setF(blankPL()); }}>Clear sheet</button>
          <button className="pl-btn" type="button" style={{ marginLeft: 'auto' }} onClick={() => window.print()}>🖨 Print / Save as PDF</button>
        </div>
        <PLForm f={f} setF={setF} />
      </div>
    </>
  );
}
